import type { JSX } from '@builder.io/qwik';
import { component$, useOnDocument, $ } from '@builder.io/qwik';
import { useRecircWidget } from '~/utilities/useRecircWidget';

type VoltaxRecirculationWidgetType = {
  placement?: string;
};

export default component$<VoltaxRecirculationWidgetType>(
  ({ placement }): JSX.Element => {
    const hasRecircWidget = useRecircWidget(placement);
    if (!hasRecircWidget) return <></>;

    useOnDocument(
      'load',
      $(() => {
        if (window.__mm_recirculation_widget_loaded__) {
          return;
        }
        window.__mm_recirculation_widget_loaded__ = true;

        const script = document.createElement('script');
        script.async = true;
        script.src =
          'https://assets.minutemediacdn.com/recirculation-widget/prod/mm-recirculation-widget.js';
        document.head.appendChild(script);
      })
    );

    return (
      <div
        data-mm-recirc
        data-experiment='article-bottom-recirc|control'
        class='voltax-recirculation-widget'
      >
        <div class='rw-widget-loading'>
          <p>
            Loading recommendations... Please wait while we load personalized
            content recommendations
          </p>
        </div>
      </div>
    );
  }
);
